import { Component } from '@angular/core';
import { BlockBaseComponent } from "../block-base/block-base.component";
import { StoreSelectorsService } from "../../../../services/store-selectors.service";
import { MatDialog } from "@angular/material/dialog";
import { TranslocoService } from "@ngneat/transloco";

@Component({
    selector: 'app-block-serial-port',
    templateUrl: './block-serial-port.component.html',
    styleUrls: ['./block-serial-port.component.scss']
})
export class BlockSerialPortComponent extends BlockBaseComponent {
    constructor(private translocoService: TranslocoService, public override storeSelector: StoreSelectorsService, public override dialog: MatDialog) {
        super(storeSelector, dialog);
    }

    override submit(formValues) {
        return super.submit(formValues);
    }

    override componentInit() {
        super.componentInit();
    }

    override componentStoreUpdates() {
        super.componentStoreUpdates();
    }

    override initRegisterDynamic() {
        this.uiConfigInit = [];
    }
}
